import { PostfixOptions } from 'components/PostfixNew/types';
import React from 'react';

import { PostfixOperandProps, View } from './index.view';

export function PostfixOperand<T extends PostfixOptions>(props: PostfixOperandProps<T>) {
  return <View {...props} />;
}
